export default __webpack_public_path__ + "static/media/avathar1.faf2a8d2.jpg";